import { useAppSelector } from '../redux/hooks';
import { useOnFarmAgreementGate } from '../pages/on-farm/OnFarmAgreementGateContext';

export const useOnFarmActionBlocked = (): boolean => {
  const { onFarmOutstandingBalanceCents, isOnFarmBlocked, locked } = useAppSelector(state => state.activeAccount);
  const hasPaymentMethod = useAppSelector(state => state.payment.addedPaymentMethod);
  const { requiresAgreementGate } = useOnFarmAgreementGate();

  return onFarmOutstandingBalanceCents > 0 || isOnFarmBlocked || locked || hasPaymentMethod === false || requiresAgreementGate;
};
